<div class="p-fluid">
  @if (singleLayoutEnabled) {
    <!-- Dashboard principal: 1 card → centrada y estirada al 50% -->
    <div class="flex justify-center">
      @for (card of items; track card) {
        <app-card-animated [item]="card" class="w-full sm:w-1/2"> </app-card-animated>
      }
    </div>
  } @else if (hasSingleCard) {
    <!-- Submódulos: 1 card → centrada y estirada al 35% -->
    <div class="flex justify-center">
      @for (card of items; track card) {
        <app-card-animated [item]="card" class="w-full sm:w-[35%]"> </app-card-animated>
      }
    </div>
  } @else {
    <!-- 2 o más cards → centradas -->
    <div class="flex flex-wrap justify-center gap-8">
      @for (card of items; track card) {
        <app-card-animated [item]="card" class="w-full sm:w-[calc(50%-1rem)] lg:w-[calc(25%-1.5rem)]"> </app-card-animated>
      }
    </div>
  }
</div>
